import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/shop-collections")({
  component: lazyRouteComponent(() => import("./-pages/admin.shop-collections")),
  head: () => ({
    meta: [
      { title: "Shop Collections Order · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
